<template lang="pug">
  v-menu(
    :close-on-content-click="false"
    :nudge-width="200"
    v-model="menu"
    offset-x
  )
    v-btn(
      class="elevation-2"
      :color="colorIconBtn"
      dark
      fab
      slot="activator"
      small
    )
      v-icon( dark ) {{ icon }}
    v-card
      h3( class="text-xs-center" ) {{ boxTitle }}
      v-divider
      v-list
        v-list-tile( avatar )
          v-list-tile-avatar
            img( 
              :src="image_logo" 
              :alt="infoSession.title" 
            )
          v-list-tile-content
            v-list-tile-title {{ infoSession.title }}
            template( v-for="item in infoSession.subtitle" )
              v-list-tile-sub-title {{ item }}
          v-list-tile-action
            slot( name="actions" )
      v-card-title.text-uppercase.justify-end.pt-0.pb-2
        strong {{ version }}
</template>

<script>
export default {
  name: "sessionBox",
  props: {
    infoSession:{
      type: Object,
      required: false,
    },
    boxTitle:{
      type: String,
      default: "Sesión Actual"
    },
    image_logo:{
      type: String,
      default: require("./logos/user_male.png"),
    },
    icon:{
      type: String ,
      default: "person"
    },
    colorIconBtn:{
      type: String,
      default: "orange",
    }
  },
  computed: {
    version() {
      return process.env.VUE_APP_VERSION
    },
  },
  data (){
    return {
      menu: false,
      /*infoSession:[
        {
          alias_name :"Coca cola 2L"
        },
        {
          alias_name : "Articulo de cumpleaños"
        },
      ]*/
    }
  },
}
</script>